export default __webpack_public_path__ + "static/media/bicycle selling.fcbcb132.png";